import { User } from '../../types/Types';
import ActionTypes from '../Action.types';

type State = {
  users: User[];
  isLoading: boolean;
  errMessage: string;
};

type Action = {
  type: string;
  payload: any;
};

function UserReducer(state: State, action: Action): State {
  switch (action.type) {
    case ActionTypes.start:
      return { ...state, isLoading: true };
    // ------------------------------------------------------------------- //
    // ----------------------------- FIND ALL----------------------------- //
    // ------------------------------------------------------------------- //
    case ActionTypes.find:
      return { ...state, isLoading: false, users: action.payload };

    // ----------------------------------------------------------------------- //
    // ----------------------------- Create ---------------------------------- //
    // ----------------------------------------------------------------------- //

    case ActionTypes.create:
      return {
        ...state,
        isLoading: false,
        users: [...state.users, { ...action.payload, id: action.payload._id }],
      };

    // ----------------------------------------------------------------------- //
    // ----------------------------- UPDATE ---------------------------------- //
    // ----------------------------------------------------------------------- //

    case ActionTypes.update:
      return {
        ...state,
        isLoading: false,
        users: state.users.map((user) =>
          user._id === action.payload._id
            ? { ...user, id: action.payload._id, ...action.payload }
            : user
        ),
      };
    // ------------------------------------------------------------------ //
    // ----------------------------- DELETE ----------------------------- //
    // ------------------------------------------------------------------ //
    case ActionTypes.delete:
      return {
        ...state,
        isLoading: false,
        users: state.users.filter((user) => user._id !== action.payload),
      };
    // ----------------------------- ERROR ----------------------------- //
    case ActionTypes.error:
      return { ...state, isLoading: false, errMessage: action.payload };
    // ----------------------------- CLEAR ----------------------------- //
    case ActionTypes.clear:
      return { ...state, isLoading: false, errMessage: '' };
    default:
      return state;
  }
}

export default UserReducer;
